import { render } from "./AgreementView.vue?vue&type=template&id=0ad9c88c&ts=true"
import script from "./AgreementView.vue?vue&type=script&lang=ts"
export * from "./AgreementView.vue?vue&type=script&lang=ts"

import "./AgreementView.vue?vue&type=style&index=0&id=0ad9c88c&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__